import React from 'react';
import styled from 'styled-components';
import Theme from '../../../Theme';

import { Text } from '../../../components/core';
import { Chevron } from '../../../components/icons';
import useMobile from '../../../other/Hooks/useMobile';

type CustomCursorProps = {
  showControls?: boolean
  mouseOnLeftSide?: boolean
  isMobile?: boolean
}

const CustomCursorContainer = styled.div`
  cursor: pointer;
  position: absolute;
  ${({ isMobile }: CustomCursorProps) => isMobile ? 'bottom: 20px;' : 'top: -120px;'}
  ${({ isMobile, mouseOnLeftSide }: CustomCursorProps) => isMobile ? (mouseOnLeftSide ? 'right: calc(50% + 20px)' : 'left: calc(50% + 20px)') : 'left: -90px'};
  will-change: transform;
  transform: translate(0px, 0px);
  z-index: 3;

  display: ${({ showControls }: CustomCursorProps) => showControls ? 'flex' : 'none'};
  align-items: center;
  color: white;

  .cursor-content {
    display: flex;
    align-items: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  .left {
    width: 133px;
    right: 30px;
    text-align: right;
    display: flex;
    justify-content: flex-end;

    svg {
      margin-left: 13px;
    }
  }

  .right {
    width: 170px;
    left: 30px;

    svg {
      margin-right: 13px;
    }
  }

  @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}){


  }

`;

const Circle = styled.div`
  width: 62px;
  height: 62px;
  border-radius: 50%;
  background-color: ${({ mouseOnLeftSide }: CustomCursorProps) => mouseOnLeftSide ? Theme.colors.BrandBlue : Theme.colors.BrandOrange};
  box-shadow: 0px 0px 13px ${({ mouseOnLeftSide }: CustomCursorProps) => mouseOnLeftSide ? Theme.colors.BrandBlue : Theme.colors.BrandOrange};

`;

type Props = {
  mouseRef?: any
  showControls?: boolean
  mouseOnLeftSide?: boolean
  onClick?: () => void
}

const CustomCursor = ({ mouseRef, showControls, mouseOnLeftSide, onClick }: Props) => {
  const key = mouseOnLeftSide ? 1 : 0
  const isMobile = useMobile()
  return (
    <CustomCursorContainer
      onClick={onClick}
      ref={mouseRef}
      showControls={showControls}
      mouseOnLeftSide={mouseOnLeftSide}
      isMobile={isMobile}
    >
      <Circle
        key={key}
        className='scale'
        mouseOnLeftSide={mouseOnLeftSide}
        showControls={showControls}
      />
      {

        mouseOnLeftSide
          ? <div className='cursor-content left'>
            <div className='text unexplore' key={key}>
              <Text variant='Cursor'>TAKE THE</Text>
              <Text variant='Cursor'>360 TOUR</Text>
            </div>
          </div>
          : <div className='cursor-content right'>
            <div className='text explore' key={key}>
              <Text variant='Cursor'>EXPLORE</Text>
              <Text variant='Cursor'>THE MAP</Text>
            </div>
          </div>
      }
    </CustomCursorContainer>
  )
}

export default CustomCursor;